// extracted by mini-css-extract-plugin
module.exports = {"content":"_3Ve0u","container":"_1L2Yv","summary":"_2obk-","expandIcon":"_3u5wV","mobile":"_34-qA"};